import { Box, Card, CircularProgress, Container, Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { authActions } from "../../store/reducer/auth-reducer";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { homePageActions } from "../../store/reducer/home";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const WalletStatement = ({ walletData, isLoginLoading }: any) => {
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession);
    const [localWalletData, setLocalWalletData] = useState<any>({ transaction_history: [], in_history: [], out_history: [] })
    const dispatch = useDispatch();

    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (Object.keys(finalData).length) {
            const data: any = {
                "app_key": "@34Y@#8deepmatka",
                "user_id": finalData.user_id
            }
            dispatch(authActions.getWalletTransactionReq(data))
        }
        const pay: any = {
            menuname: 'passbook'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [])

    // Group transactions by same time and amount
    const groupTransactions = (transactions: any[]) => {
        const grouped: any[] = [];
        const processed = new Set();
        
        transactions.forEach((item: any, index: number) => {
            if (processed.has(index)) return;
            
            // Find all transactions with same time and amount
            const similarTransactions = [item];
            processed.add(index);
            
            for (let i = index + 1; i < transactions.length; i++) {
                if (processed.has(i)) continue;
                
                const compareItem = transactions[i];
                
                // Check if same time and amount
                if (
                    compareItem.insert_date === item.insert_date && 
                    compareItem.amount === item.amount &&
                    compareItem.transaction_type === item.transaction_type
                ) {
                    similarTransactions.push(compareItem);
                    processed.add(i);
                }
            }
            
            // Calculate total amount for grouped items
            const totalAmount = similarTransactions.reduce((sum: number, t: any) => sum + parseFloat(t.amount || 0), 0);
            
            grouped.push({
                ...item,
                groupedItems: similarTransactions,
                isGrouped: similarTransactions.length > 1,
                totalAmount: similarTransactions.length > 1 ? totalAmount : item.amount
            });
        });
        
        return grouped;
    };

    useEffect(() => {
        if (Object.keys(walletData).length) {
            // Group transactions before setting
            const groupedData = {
                transaction_history: groupTransactions(walletData.transaction_history || []),
                in_history: groupTransactions(walletData.in_history || []),
                out_history: groupTransactions(walletData.out_history || [])
            };
            setLocalWalletData(groupedData);
        }

    }, [walletData])
    return (
        <Container>
            {isLoginLoading ? <div style={{ width: '100%', height: '30vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress /> </div> :

                <Card sx={{ padding: '5px 0px 5px 0px', border: 'none', boxShadow: '0px 0px 2px #adadad27' }}>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="All" {...a11yProps(0)} />
                            <Tab label="In" {...a11yProps(1)} />
                            <Tab label="Out" {...a11yProps(2)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <List sx={{ width: '100%', maxHeight: '500px', overflowY: 'scroll', overflowX: 'none' }}>
                            {localWalletData.transaction_history.map((item: any, idx: number) => (
                                <>
                                    <ListItem disablePadding sx={{ padding: 0 }}>
                                        <ListItemButton component="a" sx={{ padding: 0 }}>
                                            <ListItemText sx={{ padding: 0 }}>
                                                <Grid container>
                                                    <Grid lg={10} md={10} sm={10} xs={10} display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'center'}>
                                                        <Typography sx={{ fontSize: '0.8rem' }}>
                                                            {item.transaction_note}
                                                            {item.isGrouped && (
                                                                <span style={{ 
                                                                    marginLeft: '8px', 
                                                                    padding: '2px 8px', 
                                                                    background: '#667eea', 
                                                                    color: 'white', 
                                                                    borderRadius: '12px',
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    ×{item.groupedItems.length}
                                                                </span>
                                                            )}
                                                        </Typography>
                                                        
                                                        {item.isGrouped ? (
                                                            // Show all grouped items
                                                            <Box sx={{ marginTop: 1 }}>
                                                                {item.groupedItems.map((subItem: any, subIdx: number) => (
                                                                    <Typography key={subIdx} sx={{ fontSize: '0.7rem', color: '#666', marginLeft: 1 }}>
                                                                        • {subItem.digits || subItem.pana || 'N/A'} | {subItem.session || 'N/A'} {subItem.game_name ? `| ${subItem.game_name}` : ''}
                                                                    </Typography>
                                                                ))}
                                                            </Box>
                                                        ) : (
                                                            // Show single item details
                                                            (item.digits || item.pana) && (
                                                                <>
                                                                    <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                                                                        Number: {item.digits || item.pana} | {item.session || 'N/A'}
                                                                    </Typography>
                                                                    {item.game_name && (
                                                                        <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                                                                            Game: {item.game_name}
                                                                        </Typography>
                                                                    )}
                                                                </>
                                                            )
                                                        )}
                                                        
                                                        <Typography sx={{ fontSize: '0.8rem' }}>{item.insert_date}</Typography>
                                                    </Grid>
                                                    <Grid lg={2} md={2} sm={2} xs={2} display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'flex-end'}>
                                                        <Typography>{(item.transaction_type == 2) ? '-' : ''} {item.isGrouped ? item.totalAmount : item.amount}</Typography>
                                                        <Typography sx={{ fontSize: '0.8rem' }}>{item.tx_request_number}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </ListItemText>
                                        </ListItemButton>
                                    </ListItem>
                                    <Divider />
                                </>
                            ))}
                        </List>

                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <List sx={{ width: '100%', maxHeight: '400px', overflowY: 'scroll', overflowX: 'none' }}>
                            {localWalletData.in_history.map((item: any, idx: number) => (
                                <>
                                    <ListItem disablePadding>
                                        <ListItemButton component="a" sx={{ padding: 0 }}>
                                            <ListItemText sx={{ padding: 0 }}>
                                                <Grid container>
                                                <Grid lg={10} md={10} sm={10} xs={10} display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'center'}>
                                                        <Typography sx={{ fontSize: '0.8rem' }}>
                                                            {item.transaction_note}
                                                            {item.isGrouped && (
                                                                <span style={{ 
                                                                    marginLeft: '8px', 
                                                                    padding: '2px 8px', 
                                                                    background: '#28a745', 
                                                                    color: 'white', 
                                                                    borderRadius: '12px',
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    ×{item.groupedItems.length}
                                                                </span>
                                                            )}
                                                        </Typography>
                                                        
                                                        {item.isGrouped ? (
                                                            <Box sx={{ marginTop: 1 }}>
                                                                {item.groupedItems.map((subItem: any, subIdx: number) => (
                                                                    <Typography key={subIdx} sx={{ fontSize: '0.7rem', color: '#666', marginLeft: 1 }}>
                                                                        • {subItem.digits || subItem.pana || 'N/A'} | {subItem.session || 'N/A'} {subItem.game_name ? `| ${subItem.game_name}` : ''}
                                                                    </Typography>
                                                                ))}
                                                            </Box>
                                                        ) : (
                                                            (item.digits || item.pana) && (
                                                                <>
                                                                    <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                                                                        Number: {item.digits || item.pana} | {item.session || 'N/A'}
                                                                    </Typography>
                                                                    {item.game_name && (
                                                                        <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                                                                            Game: {item.game_name}
                                                                        </Typography>
                                                                    )}
                                                                </>
                                                            )
                                                        )}
                                                        
                                                        <Typography sx={{ fontSize: '0.8rem' }}>{item.insert_date}</Typography>

                                                    </Grid>
                                                    <Grid lg={2} md={2} sm={2} xs={2} display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'flex-end'}>
                                                        <Typography>{(item.transaction_type == 2) ? '-' : ''} {item.isGrouped ? item.totalAmount : item.amount}</Typography>
                                                        <Typography sx={{ fontSize: '0.8rem' }}>{item.tx_request_number}</Typography></Grid>
                                                </Grid>
                                            </ListItemText>
                                        </ListItemButton>
                                    </ListItem>
                                    <Divider />
                                </>
                            ))}
                        </List>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <List sx={{ width: '100%', maxHeight: '400px', overflowY: 'scroll', overflowX: 'none' }}>
                            {localWalletData.out_history.map((item: any, idx: number) => (
                                <>
                                    <ListItem disablePadding>
                                        <ListItemButton component="a" sx={{ padding: 0 }}>
                                            <ListItemText sx={{ padding: 0 }}>
                                                <Grid container>
                                                <Grid lg={10} md={10} sm={10} xs={10} display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'center'}>
                                                        <Typography sx={{ fontSize: '0.8rem' }}>
                                                            {item.transaction_note}
                                                            {item.isGrouped && (
                                                                <span style={{ 
                                                                    marginLeft: '8px', 
                                                                    padding: '2px 8px', 
                                                                    background: '#dc3545', 
                                                                    color: 'white', 
                                                                    borderRadius: '12px',
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    ×{item.groupedItems.length}
                                                                </span>
                                                            )}
                                                        </Typography>
                                                        
                                                        {item.isGrouped ? (
                                                            <Box sx={{ marginTop: 1 }}>
                                                                {item.groupedItems.map((subItem: any, subIdx: number) => (
                                                                    <Typography key={subIdx} sx={{ fontSize: '0.7rem', color: '#666', marginLeft: 1 }}>
                                                                        • {subItem.digits || subItem.pana || 'N/A'} | {subItem.session || 'N/A'} {subItem.game_name ? `| ${subItem.game_name}` : ''}
                                                                    </Typography>
                                                                ))}
                                                            </Box>
                                                        ) : (
                                                            (item.digits || item.pana) && (
                                                                <>
                                                                    <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                                                                        Number: {item.digits || item.pana} | {item.session || 'N/A'}
                                                                    </Typography>
                                                                    {item.game_name && (
                                                                        <Typography sx={{ fontSize: '0.75rem', color: '#666' }}>
                                                                            Game: {item.game_name}
                                                                        </Typography>
                                                                    )}
                                                                </>
                                                            )
                                                        )}
                                                        
                                                        <Typography sx={{ fontSize: '0.8rem' }}>{item.insert_date}</Typography>

                                                    </Grid>
                                                    <Grid lg={2} md={2} sm={2} xs={2} display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'flex-end'}>
                                                        <Typography>{(item.transaction_type == 2) ? '-' : ''} {item.isGrouped ? item.totalAmount : item.amount}</Typography>
                                                        <Typography sx={{ fontSize: '0.8rem' }}>{item.tx_request_number}</Typography></Grid>
                                                </Grid>
                                            </ListItemText>
                                        </ListItemButton>
                                    </ListItem>
                                    <Divider />
                                </>
                            ))}
                        </List>
                    </CustomTabPanel>

                </Card>}

        </Container>
    )
}


const mapStateToProps = (state: any) => ({
    isAuthenticated: state.authentication.isAuthenticated,
    isLoginLoading: state.authentication.isLoginLoading,
    walletData: state.authentication.walletData,
})


export default connect(mapStateToProps)(WalletStatement);